var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`relative-position overflow-hidden full-width rounded-borders-lg bg-${_vm.baseColor}`,style:({ height: _vm.height })},[_c('div',{class:`absolute-left full-height bg-${_vm.computedProgressColor}`,style:({ width: `${_vm.progress}%` })})])
}
var staticRenderFns = []

export { render, staticRenderFns }